export default __webpack_public_path__ + "static/media/pantry1-afterG.850250e9.jpg";